export const DEFAULT_QUOTATION_FILTERS = {
  searchText: '',
  branches: [],
  createdBy: [],
  // advisors: [],
  insuranceCarriers: [],
  createdAtStart: null,
  createdAtEnd: null,
  updatedAtStart: null,
  updatedAtEnd: null,
  vehicleStates: [],
  vehicleModelStart: null,
  vehicleModelEnd: null,
  vehicleClasses: [],
  vehicleCirculationCities: [],
  vehicleServiceTypes: [],
  vehicleIsUtilitarian: null,
}